<template>
  <i class="icon fa fa-arrow-left"
    style="margin-top:25px;margin-bottom:25px"
    :style="customStyle"
    @click="goBack(returnUrl)">
    <span class="ml-1 backLabel" v-if="backLabel" style="font-size:large">{{ $t('common.bck') }}</span>
  </i>
</template>
<script>
/* TLV 24/09/2020 -  Component pour tous les boutons de Retour */
import {loadPage} from '@/helpers/routing'
export default {
  name: 'backButton',
  props: {
    backLabel: {
      type: Boolean,
      default: true
    },
    customStyle: {
      type: String,
      default: ''
    },
    returnUrl: {
      type: String,
      default: 'none'
    }
  },
  methods: {
    goBack (url) {
      if (url !== 'none') {
        loadPage(this, {url: url})
      } else {
        /* On évite d'afficher la page de login a un utilisateur deja connecte */
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
          loadPage(this, {url: '/home/'})
        } else {
          this.$bus.$emit('router-back')
          this.$f7.mainView.router.back()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// backButton.vue?23518c24